import { useState, useEffect } from 'react';
import { useNavigate,redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
// @mui
import { styled,createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import { Link, Container, Typography, Divider,Box ,Card,CardHeader, CardContent} from '@mui/material';

// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Logo from '../components/logo';

// sections
import { LoginForm } from '../sections/auth/login';


const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
         
          backgroundImage: "url(/background.webp)"        }

      }
    }
  }
});

const API_URL = `${process.env.REACT_APP_API_URL}`;

// ----------------------------------------------------------------------

export default function LoginPage() {
  const navigate = useNavigate();
  const [refreshPage, setfreshPage] = useState(false);


  useEffect(() => {
    const token = localStorage.getItem('token');
    const bearer = "Bearer ";
    fetch(`${API_URL}/authen`,{method: 'post',
    headers: {"Content-Type": "application/json", "Authorization": bearer+token}

    }).then(response => response.json())
    .then(data => {
      if(data.status === 'ok'){
        navigate("/dashboard");
      }else{
          localStorage.clear();
          sessionStorage.clear()
          redirect("/login");
      }
    })
  },[]);

  const handleSingUp = async e => {
    e.preventDefault();
    navigate("/register");
  }

  return (
    <>
      <Helmet>
        <title> Sign In </title>
      </Helmet>
      <ThemeProvider theme={theme}>
      <CssBaseline />
       
      <Container component="main" maxWidth="xs">
        <Box align="center">
          <Logo sx={{width:180,marginTop: 2}} />
        </Box>
        <Card sx={{ maxWidth: "sm",my: 1,borderRadius:5 }}>
          <CardHeader variant="h2" title="Sign In" align="center"/>
          <CardContent >
                <LoginForm />
                <Divider sx={{ my: 3 }}>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    OR
                  </Typography>
                </Divider>
                <Typography variant="body2" sx={{ mb: 3 }}>
                  Don’t have an account? {''}
                  <Link variant="subtitle2" onClick={handleSingUp} sx={{cursor: 'pointer'}}>Get Started</Link>
                </Typography>
             
          </CardContent>
        </Card>
      </Container>
    </ThemeProvider>
    </>
  );

}
